module.exports = __webpack_public_path__ + "img/header.ce971a60.png";